<template>
  <o-confirmation-view
    image="images/vab-header.jpg"
    message="Je bestelling is met succes geregistreerd. Je krijgt zo dadelijk een e-mail met meer informatie."
    nav-bar-title="VAB Assistance"
  />
</template>

<script>
import OConfirmationView from '@/components/OConfirmationView.vue'
export default {
  name: 'VABConfirmation',
  components: {
    OConfirmationView
  }
}
</script>
